/**
 * Common/shared API types - errors, pagination, utilities.
 */

// ============================================================
// Error Types
// ============================================================

export interface ApiErrorResponse {
  error?: string;
  detail?: string;
  message?: string;
  errors?: Record<string, string[]>;
  code?: string;
}

export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public data?: ApiErrorResponse | null
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError;
}

// ============================================================
// Pagination Types
// ============================================================

export interface PaginatedResponse<T> {
  items: T[];
  total: number;
  page: number;
  page_size: number;
  pages: number;
}

export interface PaginationParams {
  page?: number;
  page_size?: number;
  sort_by?: string;
  sort_order?: 'asc' | 'desc';
}
